import React, { useState } from "react";
import { ColorRing } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { createUserWithEmailAndPassword } from "firebase/auth";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import Swal from "sweetalert";
import PrivacyPolicyModal from "../../components/Modal/PrivacyPolicy";
import TermsOfServiceModal from "../../components/Modal/TermsModal";
import { auth, firestoredDB } from "../../config/firebase";
import { clearMessage, setMessage } from "../../redux/message";
import { playAudio } from "../../utils/btnAudio";
import Layout from "../../components/Layout";
import { Dark_White_mode } from "../../utils/constants";
import { CButton, CookEInput } from "../../components/CommonComponents";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const initialState = {
  fullName: "",
  email: "",
  password: "",
  confirmPassword: "",
  username: "",
};

function SignUp() {
  const [values, setValues] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [visible, setIsVisible] = useState(false);
  const { message } = useSelector((state) => state.message);
  const [openPrivacyModal, setPrivacyModalOpen] = useState(false);
  const [openTermsModal, setTermsModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    setIsVisible(true);

    try {
      if (values.password !== values.confirmPassword) {
        Swal({
          icon: "error",
          title: "Passwords do not match",
          showConfirmButton: false,
          timer: 2000,
          confirmButtonColor: "#f0481a",
        });
        setIsVisible(false);
        return;
      }

      const user = await createUserWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );
      const uid = user.user.uid;
      const userRef = collection(firestoredDB, "Users");
      let userName =
        values?.fullName?.split(" ")[0]?.toLowerCase() +
        Math.floor(Math.random() * 1000000);
      await addDoc(userRef, {
        userId: uid,
        email: values.email,
        username: userName,
        personalName: values.fullName,
        subscriptionData: {
          duration: "Month",
          isActive: false,
          plan: "free",
        },
        tokens: {
          dishTokens: 6,
          recipeTokens: 3,
        },
        createdAt: serverTimestamp(), // Add the server timestamp
      });

      Swal({
        icon: "success",
        title: "Account created successfully with Free Trial",
        showConfirmButton: false,
        timer: 2000,
        confirmButtonColor: "#f0481a",
      });
      setTimeout(() => {
        navigate("/signin");
      }, 2000);
    } catch (error) {
      dispatch(setMessage(error.message.substring(9)));
    }
    setTimeout(() => {
      dispatch(clearMessage());
    }, 5000);
    setIsVisible(false);
  };

  const checkUsernameAvailability = async (username) => {
    const userRef = collection(firestoredDB, "Users");
    const snapshot = await userRef
      .where("username", "==", username?.toLowerCase())
      .get();

    // Convert usernames from the database to lowercase for comparison
    const usernames = snapshot.docs.map((doc) =>
      doc.data().username.toLowerCase()
    );

    // Check if the username exists
    return usernames.includes(username?.toLowerCase());
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    // console.log(values);
    // // // Check username availability
    // const usernameExists = await checkUsernameAvailability(values.username);
    // if (usernameExists) {
    //   // Show error message
    //   dispatch(setMessage("Username is already taken."));
    //   return;
    // } else {
    handleRegister();
    // }
  };

  return (
    <Layout variant="auth">
      <div className="">
        <h1 className={`${Dark_White_mode} text-3xl font-bold`}>
          Welcome to <span className="text-orange-50">COOK-E</span>
        </h1>

        {/* Form */}
        <div className="w-full px-4 mt-8">
          <form onSubmit={onSubmit}>
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <CookEInput
                  name="fullName"
                  value={values.fullName}
                  onChange={handleChange}
                  type="text"
                  className="form-input w-full text-gray-700"
                  placeholder="Your name"
                  required
                  label={"Name"}
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <CookEInput
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  type="email"
                  className="form-input w-full text-gray-700"
                  placeholder="your email"
                  required
                  label="Email"
                />
              </div>
            </div>
            {/* <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <CookEInput
                  name="username"
                  value={values.username}
                  onChange={handleChange}
                  type="text"
                  className="form-input w-full text-gray-700"
                  placeholder="Username"
                  required
                  label="Username"
                />
              </div>
            </div> */}
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3 relative">
                <CookEInput
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  className="form-input w-full text-gray-700"
                  placeholder="Password (at least 8 characters)"
                  required
                  label="Password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute top-[36px] right-8 flex items-center text-sm sm:text-base md:text-lg font-babas text-gray-400  transition duration-150 ease-in-out"
                >
                  {showPassword ? (
                    <FaRegEyeSlash></FaRegEyeSlash>
                  ) : (
                    <FaRegEye></FaRegEye>
                  )}
                </button>
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3 relative">
                <CookEInput
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-input w-full text-gray-700"
                  placeholder="Confirm Password"
                  required
                  label="Confirm Password"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  className="absolute top-[36px] right-8 flex items-center text-sm sm:text-base md:text-lg font-babas text-gray-400  transition duration-150 ease-in-out"
                >
                  {showConfirmPassword ? (
                    <FaRegEyeSlash></FaRegEyeSlash>
                  ) : (
                    <FaRegEye></FaRegEye>
                  )}
                </button>
              </div>
            </div>
            <p className="my-2 mx-3   text-md font-bold text-center text-gray-700">
              {message && (
                <div
                  className={`${Dark_White_mode} text-white h-full `}
                  role="alert"
                >
                  {message.includes("(auth/email-already-in-use).") ? (
                    <span>
                      Email already in use{" "}
                      <button
                        onClick={() => navigate("/signin")}
                        className="underline text-orange-500 transition duration-150 ease-in-out"
                      >
                        Sign in
                      </button>
                    </span>
                  ) : (
                    message
                  )}
                </div>
              )}
            </p>
            <div className="text-[14px] text-gray-200 space-x-2 ">
              <input type="checkbox" className="form-checkbox" required />
              <span className={`${Dark_White_mode}`}>
                I agree to be Cook-E per the Cook-E{" "}
                <span
                  onClick={() => {
                    setPrivacyModalOpen(true);
                  }}
                  className="cursor-pointer  text-orange-50 hover:underline  transition duration-150 ease-in-out"
                >
                  Privacy Policy
                </span>
                .
              </span>
            </div>
            {/* terms and services */}
            <div className="flex items-center space-x-2 mt-2">
              <input type="checkbox" className="form-checkbox" required />
              <span className={`${Dark_White_mode} text-[14px]`}>
                I agree to the Cook-E{" "}
                <span
                  onClick={() => setTermsModalOpen(true)}
                  className="cursor-pointer  text-orange-50 hover:underline  transition duration-150 ease-in-out"
                >
                  Terms of Service
                </span>
              </span>
            </div>
            <div className="flex flex-wrap mt-4">
              <CButton type="submit" className={"w-full cursor-pointer "}>
                Sign Up
              </CButton>
              {/* </Link> */}
            </div>
            {/* <p className="mt-8 mx-3 text-xs font-bold text-center text-gray-700">
                    {message && (
                      <div
                        className={successful ? "text-green-600" : "text-red-500"}
                        role="alert"
                      >
                        {message}
                      </div>
                    )}
                  </p> */}
          </form>
          <div
            className={`${Dark_White_mode} flex space-x-2 justify-center text-center mt-2`}
          >
            Already using Cook-E?{" "}
            <div
              to="signin"
              onClick={() => navigate("/signin")}
              className="text-orange-400 ml-2 hover:underline transition duration-150 ease-in-out"
            >
              Sign in
            </div>
          </div>
        </div>

        {visible && (
          <div className="z-50 absolute top-[50%] left-[50%] -translate-x-[50%]">
            <ColorRing
              visible={true}
              height="100"
              width="100"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
            />
          </div>
        )}
        {/* {notification && (
                <Notification
                  status={notification.status}
                  title={notification.title}
                  message={notification.message}
                />
              )} */}
      </div>
      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal
        open={openPrivacyModal}
        onClose={setPrivacyModalOpen}
      ></PrivacyPolicyModal>

      {/* Terms of Service Modal */}
      <TermsOfServiceModal
        open={openTermsModal}
        onClose={setTermsModalOpen}
      ></TermsOfServiceModal>
    </Layout>
  );
}

export default SignUp;
